import {
    LOANFORMAT_ALL_OBJECT,
    LOANFORMAT_EAUDIOBOOK_OBJECT,
    LOANFORMAT_EBOOK_OBJECT,
    LOANFORMAT_EPRESS_OBJECT
} from '../loanFormat/constants';

export const getLoanFormat = (loanFormat?: string) => {
    switch (loanFormat?.toLowerCase()) {
        case 'ebooks':
            return LOANFORMAT_EBOOK_OBJECT;
        case 'eaudiobooks':
            return LOANFORMAT_EAUDIOBOOK_OBJECT;
        case 'emagazines':
        case 'epress':
            return LOANFORMAT_EPRESS_OBJECT;

        default:
            return LOANFORMAT_ALL_OBJECT;
    }
};
